<div class="wsmenucontainer clearfix">

<div class="wrap2">
	<app-slider></app-slider>
</div>



<div class="wrapper">
<div class="section fp-auto-height fp-section fp-table" data-anchor="whyPage" style="height: 600px;">

    <div id="trigger1" class="whySection" data-parallax="{&quot;y&quot;: -40}" style="transform:translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1); -webkit-transform:translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scaleX(1) scaleY(1) scaleZ(1); ">
        <div class="leftSvg">

			<svg class="meddio" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				 viewBox="0 0 264.2 489.3" style="enable-background:new 0 0 264.2 489.3;" xml:space="preserve">
				<style type="text/css">
					.st28{fill:none;stroke:#344C6F;stroke-width:0.5;stroke-miterlimit:10;}
					.st29{fill:none;stroke:#344C6F;stroke-width:0.5;stroke-miterlimit:10;}
					
				</style>
				<path id="dot3" class="st28" d="M2.3,7.3c131.4,0,238,106.6,238,238s-106.6,238-238,238"/>
			
			</svg>

        </div>

        
        <div class="rightPhoto">
        	<div class="badge">
				<img class="work" src="../../../../assets/img/sello-GC-PP-Sell-Service-Outline.png" alt="work transformation">
				<img class="work" src="../../../../assets/img/Work_Transformation.webp" alt="work transformation">
				&nbsp;&nbsp;
				<img class="work" src="../../../../assets/img/sello-GWS-PP-Sell-Service-Outline.png" alt="work transformation">
        		<img class="rPhoto" src="../../../../assets/img/work.webp" alt="trabajo en la nube"/>	
        	</div>
        </div>



<div class="wrapper2">
<div class="whyTable">
    <div id="trigger8" class="whyColumnLefto">
    	
        <h2>Cloud journey with Peace of Mind and extra Value</h2>
    </div>

    <div class="whyColumnCenter">
    	<div class="icons">
            <div class="iconRow icon1">
                <div class="circle">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						 viewBox="0 0 40.4 40.5" style="enable-background:new 0 0 40.4 40.5;" xml:space="preserve">
					<style type="text/css">
						.st0{fill:#1a2751;stroke:#344C6F;stroke-width:0;stroke-miterlimit:10;}
					</style>
					<path id="word3" class="st0" style="fill:#e8effe;" d="M39.7,20.3c0,10.7-8.7,19.5-19.5,19.5S0.7,31.1,0.7,20.3S9.4,0.8,20.2,0.8c8.7,0,16.1,5.8,18.6,13.7
						C38.9,14.5,39.7,17.2,39.7,20.3z"/>
					</svg> 

                    <img class="target" src="../../../../assets/img/cloud-icon.svg" alt="">
                </div>
                <div class="title">{{ 'cloud.title1' | translate }}</div>
            </div>
            <div class="iconRow icon2 middle centerIc">
                <div class="circle">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						 viewBox="0 0 40.4 40.5" style="enable-background:new 0 0 40.4 40.5;" xml:space="preserve">
					<style type="text/css">
						.st0{fill:none;stroke:#344C6F;stroke-width:0;stroke-miterlimit:10;}
					</style>
					<path id="word4" class="st0" style="fill:#e8effe;" d="M39.7,20.3c0,10.7-8.7,19.5-19.5,19.5S0.7,31.1,0.7,20.3S9.4,0.8,20.2,0.8c8.7,0,16.1,5.8,18.6,13.7
						C38.9,14.5,39.7,17.2,39.7,20.3z"/>
					</svg>
                    <img class="target" src="../../../../assets/img/efficiency-icon.svg" alt="">
                </div>
                <div class="title lite">{{ 'cloud.title2' | translate }}</div>
            </div>
            <div class="iconRow icon3 middle">
                <div class="circle">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						 viewBox="0 0 40.4 40.5" style="enable-background:new 0 0 40.4 40.5;" xml:space="preserve">
					<style type="text/css">
						.st0{fill:none;stroke:#344C6F;stroke-width:0;stroke-miterlimit:10;}
					</style>
					<path id="word2" class="st0" style="fill:#e8effe;" d="M39.7,20.3c0,10.7-8.7,19.5-19.5,19.5S0.7,31.1,0.7,20.3S9.4,0.8,20.2,0.8c8.7,0,16.1,5.8,18.6,13.7
						C38.9,14.5,39.7,17.2,39.7,20.3z"/>
					</svg>
                    <img class="target" src="../../../../assets/img/risk-icon.svg" alt="">
                </div>
                <div class="title">{{ 'cloud.title3' | translate }}</div>
            </div>
            <div class="iconRow icon4">
                <div class="circle">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						 viewBox="0 0 40.4 40.5" style="enable-background:new 0 0 40.4 40.5;" xml:space="preserve">
					<style type="text/css">
						.st0{fill:none;stroke:#344C6F;stroke-width:0;stroke-miterlimit:10;}
					</style>
					<path id="word" class="st0" style="fill:#e8effe;" d="M39.7,20.3c0,10.7-8.7,19.5-19.5,19.5S0.7,31.1,0.7,20.3S9.4,0.8,20.2,0.8c8.7,0,16.1,5.8,18.6,13.7
						C38.9,14.5,39.7,17.2,39.7,20.3z"/>
					</svg>
                    <img class="target" src="../../../../assets/img/money-icon.svg" alt="">
                </div>
                <div class="title">{{ 'cloud.title4' | translate }}</div>
            </div>
        </div>
    	

    </div>


</div>
</div>

</div>

</div>
</div>


<div class="space2"></div>


<div class="content-area">
	<div class="wrap">


		<section class="vc_section">

			<div class="flex6 website">
				<div class="elementb box">
					<div class="high">
						<img class="icloud-b" src="../../../../assets/img/cloud-b.svg" alt="cloud">
						<img class="icloud" src="../../../../assets/img/cloud.svg" alt="cloud">
						<div class="table">
								<div class="cell figure">
								    <span>100</span>
								</div>
							<div><p>%</p></div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title5' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<img class="icloud-b" src="../../../../assets/img/user-b.svg" alt="cloud">
						<img class="icloud" src="../../../../assets/img/user.svg" alt="">
						<div class="table">
							<div><p>+</p></div>
							<div class="cell figure">
							    <span>15</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title6' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<img class="icloud-b" src="../../../../assets/img/empresas-b.svg" alt="">
						<img class="icloud" src="../../../../assets/img/empresas.svg" alt="">
						<div class="table">
							<div><p>+</p></div>
							<div class="cell figure">
							    <span>+4,500</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title7' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<img class="icloud-b" src="../../../../assets/img/cloud-b.svg" alt="">
						<img class="icloud" src="../../../../assets/img/cloud.svg" alt="">
						<div class="table">
							<div class="cell figure">
							    <span>143</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title8' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<img class="icloud-b" src="../../../../assets/img/cobertura-b.svg" alt="">
						<img class="icloud" src="../../../../assets/img/cobertura-icon.svg" alt="">
						<div class="table">
							<div class="cell figure">
							    <span>27</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title9' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<img class="icloud-b" src="../../../../assets/img/tool-icon-b.svg" alt="">
						<img class="icloud" src="../../../../assets/img/tool-icon.svg" alt="">
						<div class="table">
							<div class="cell figure">
							    <span>43,500</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title10' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high" style="align-items: center;">
						<img class="icloud-b" src="../../../../assets/img/services-icon-b.svg" alt="">
						<img class="icloud" src="../../../../assets/img/services-icon.svg" alt="">
					</div>
					<div class="low">
						<h3>{{ 'cloud.title11' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high" style="align-items: center;">
						<img class="icloud-b" src="../../../../assets/img/experiencia-b.svg" alt="">
						<img class="icloud" src="../../../../assets/img/experiencia.svg" alt="">
					</div>
					<div class="low">
						<h3>{{ 'cloud.title12' | translate }}</h3>
					</div>
				</div>
			</div>
		</section>



	</div>
</div>


<div class="space"></div>


<div class="fondo9">
	<div class="content-area">
		<div class="wrap">

			

			<div class="fluid9">
		

				<img class="aro" id="loading" src="../../../../assets/img/aro.webp" alt="aro">
				<div class="white">
					<div class="box10">
						<div class="inner">
							<img class="gocloud" src="../../../../assets/img/gocloud.svg" alt="cloud">
							<h3>Google Cloud</h3>
							<p>{{ 'cloud.title13' | translate }}</p>
						</div>
					</div>
				</div>

				<div class="white">
					<div class="box11">
						<img class="work2" src="../../../../assets/img/Work_Transformation.webp" alt="Work Transformation">
					</div>
				</div>

				
				
				<div class="white">
					<div class="box10">
						<div class="inner">
							<img class="gocloud" src="../../../../assets/img/gocloud.svg" alt="cloud">
							<h3>Google Cloud</h3>
							<p>{{ 'cloud.title14' | translate }}</p>
						</div>
					</div>
				</div>


				
			</div>

			<div class="fluid10">
				<div class="white">
					<div class="box10">
						<img class="work3" src="../../../../assets/img/sello-GC-PP-Sell-Service-Outline.png" alt="Work Transformation">
					</div>
				</div>
				<div class="white">
					<div class="box10">
						<img class="work3" src="../../../../assets/img/sello-GC_2023_PartneroftheYear_Expansion-Google_Workspace_LatinAmerica.png" alt="Work Transformation">
					</div>
				</div>
				<div class="white">
					<div class="box10">
						<img class="work3" src="../../../../assets/img/sello-GWS-PP-Sell-Service-Outline.png" alt="Work Transformation">
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="space"></div>

<div class="padded">
	<div class="title">
		<h3>{{ 'cloud.title15' | translate }}</h3>
	</div>
	<app-carousel></app-carousel>
</div>

<div id="iform" style="margin-bottom: -40px;">
	<app-form></app-form>
</div>



















		



		









